/**
 * Preset ranges beside the calendar. One list of buttons: the stylesheet lays
 * it out as a rail down the left when the picker is wide and a scrolling row
 * of chips above the calendar when it is not.
 */
import { Check } from 'lucide-react';
import { useId } from 'react';

import { isQuickPickApplied, type DateTimeRange, type QuickPick } from './date-time-range';

export interface QuickPicksProps {
  picks: QuickPick[];
  range: DateTimeRange;
  onPick: (pick: QuickPick) => void;
}

export function QuickPicks({ picks, range, onPick }: QuickPicksProps) {
  const headingId = useId();
  return (
    <div role="group" aria-labelledby={headingId} className="dtr-picks">
      <div id={headingId} className="dtr-picks-title">
        Quick picks
      </div>
      {picks.map((p) => {
        const on = isQuickPickApplied(p, range);
        return (
          <button
            key={p.label}
            type="button"
            aria-pressed={on}
            className="dtr-pick"
            onClick={() => onPick(p)}
          >
            <span className="dtr-pick-label">{p.label}</span>
            {on && <Check size={13} aria-hidden className="dtr-pick-check" />}
          </button>
        );
      })}
    </div>
  );
}
